//Helpers
import { LogError } from "../../../../helpers/logger"

//PrimeReact
import { Tree } from "primereact/tree"
import { useEffect, useState } from "react"
import elementTypes from "./Elements/elementTypes"

//Styles
import myStyles from "../../../../styles/assessments/ManagementFormBuilder.module.css"

export default function FormBuilderOutline({
  questionOrders,
  onElementSelect,
}) {
  const [selectedKey, setSelectedKey] = useState("")
  const [nodes, setNodes] = useState([])
  const [questionOrderMap, setQuestionOrderMap] = useState({})

  const getNewNode = (key, label, icon, children) => {
    return { key: key, label: label, icon: icon, children: children }
  }

  useEffect(() => {
    let newNodes = []
    let newQuestionOrderMap = {}

    questionOrders?.forEach((orderEntry) => {
      let newNode = undefined
      let newOrderId = undefined

      if (orderEntry.question) {
        const elementProfile = elementTypes.findTypeProfile(
          orderEntry.question.type
        )

        newNode = getNewNode(
          orderEntry.id,
          orderEntry.question.text,
          elementProfile?.icon ? (
            <span className={`material-icons`}>{elementProfile?.icon}</span>
          ) : null,
          undefined
        )
      } else if (orderEntry.questionGroup) {
        const elementProfile = elementTypes.findTypeProfile(
          elementTypes.groupElementId
        )

        newNode = getNewNode(
          orderEntry.id,
          orderEntry.questionGroup.name,
          elementProfile?.icon ? (
            <span className={`material-icons`}>{elementProfile?.icon}</span>
          ) : null,
          []
        )

        orderEntry.questionGroup.questions?.forEach((question) => {
          const questionElementProfile = elementTypes.findTypeProfile(
            question.type
          )

          newQuestionOrderMap[question.id] = orderEntry.id

          const newQuestionNode = getNewNode(
            question.id,
            question.text,
            questionElementProfile?.icon ? (
              <span className={`material-icons`}>
                {questionElementProfile?.icon}
              </span>
            ) : null
          )

          newNode.children = [...newNode.children, newQuestionNode]
        })
      } else {
        LogError(`Unknown orderEntry type`, orderEntry)
      }

      if (newNode) {
        newNodes = [...newNodes, newNode]
      }
    })

    setNodes(newNodes)
    setQuestionOrderMap(newQuestionOrderMap)
  }, [questionOrders])

  const NodeTemplate = (node) => {
    return (
      <div className={myStyles.outlineNode}>
        {node.icon} {node.label}
      </div>
    )
  }

  return (
    <Tree
      value={nodes}
      selectionMode="single"
      selectionKeys={selectedKey}
      onSelectionChange={(e) => {
        setSelectedKey(e.value)

        if (onElementSelect) {
          //If questionGroupQuestions has a value for the selection, it is within a questionGroup
          if (questionOrderMap[e.value]) {
            onElementSelect(questionOrderMap[e.value], e.value)
          } else {
            onElementSelect(e.value)
          }
        }
      }}
      nodeTemplate={NodeTemplate}
      filter
      filterMode="strict"
      filterPlaceholder="Enter search phrase"
      className={myStyles.outlineTree}
      emptyMessage={"No elements found"}
    />
  )
}
